import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor() { }

  isActiveJWTToken() {
    let session = sessionStorage.getItem('JWT_TOKEN');
    return (session) ? true : false;
  }

}
